// extracted by mini-css-extract-plugin
export default {"table":"Table_table__P3S5x","th":"Table_th__7EDPD","hiden":"Table_hiden__0lVZM"};